import React from "react";
import ReportProblemIcon from '@material-ui/icons/ReportProblem';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ErrorIcon from '@material-ui/icons/Error';
import { i18n } from "../../translate/i18n";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@material-ui/core";
import { ThemeContext } from '../../context/Theme/ThemeContext';
export const ModalPadrao = ({ type, titlePrincipal, messagePrincipal, open, onClose, onConfirm }) => {
	const { darkMode } = React.useContext(ThemeContext);

		const ModalType = {
				excluir: {
						title: titlePrincipal ?? "Confirmar Exclusão",
						message: messagePrincipal ?? "Tem certeza que deseja excluir este item? Essa ação não pode ser desfeita.",
						confirmButtonText: "Excluir",
						cancelButtonText: "cancelar",
						color: "#D4183D",
						icon: <DeleteForeverIcon />
				},
				sucess: {
						title: titlePrincipal ?? "Operação concluída",
						message: messagePrincipal ?? "Sua operação foi realizada com sucesso! Todas as alterações foram salvas.",
						confirmButtonText: "Entendi",
						cancelButtonText: "Fechar",

						color: "#2DA63D",
						icon: <CheckCircleOutlineIcon />
				},
				info: {
						title: titlePrincipal ?? "Informação importante",
						message: messagePrincipal ?? "Você está prestes a acessar uma nova funcionalidade. Certifique-se de que tem as permissões necessárias.",
						confirmButtonText: "prosseguir",
						cancelButtonText: "cancelar",

						color: "#F69900",
						icon: <ErrorIcon />
				},
				aviso: {
						title: titlePrincipal ?? "Atenção necessária",
						message: messagePrincipal ?? "Esta operação pode causar alterações importantes no sistema. Deseja continuar?",
						confirmButtonText: "Continuar",
						cancelButtonText: "cancelar",
						color: "#375DFB",
						icon: <ReportProblemIcon />
				}
		}

		const modal = ModalType[type]
		if (!modal) return null

		return (
				<Dialog
						open={open}
						onClose={() => onClose(false)}
						aria-labelledby="confirm-dialog"
						PaperProps={{
								style: {
										borderRadius: 15,
										borderColor: modal.color,
								},
						}}
				>
						<div style={{ borderRadius: 10, display: "flex", gap: 20, padding: "2rem", flexDirection: "column" }}>


								<div>
										<h1 style={{ fontWeight: 500 }}>{modal.title}</h1>
										<h3 style={{ fontWeight: 500, color: "gray", marginTop: 10 }}>{modal.message}</h3>
								</div>
								<div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
										<button
												style={{
														padding: " 0.5rem 1.5rem",
														fontSize: "1.2rem",
														borderRadius: 10,
														border: "none",
														cursor: "pointer",
														background:  darkMode ? "#292d35" : "#E5E7EB"
												}}
												onClick={() => onClose(true)}
												type="button">{modal.cancelButtonText}
										</button>

										<button
												onClick={() => {
														onClose(false);
														onConfirm();
												}}
												style={{
														padding: " 0.5rem 1.5rem",
														fontSize: "1.2rem",
														borderRadius: 10,
														border: "none",
														cursor: "pointer", backgroundColor: "#364153", color: "white"
												}}
												type="button">
												{modal.confirmButtonText}
										</button>
								</div>

						</div>
				</Dialog>

		)
}
